var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrimage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.5V20H15V22.5H12.5ZM10 20V13.75H12.5V20H10ZM20 16.25V11.25H22.5V16.25H20ZM17.5 11.25V8.75H20V11.25H17.5ZM2.5 13.75V11.25H5V13.75H2.5ZM0 11.25V8.75H2.5V11.25H0ZM11.25 2.5V0H13.75V2.5H11.25ZM1.875 5.625H5.625V1.875H1.875V5.625ZM0 7.5V0H7.5V7.5H0ZM1.875 20.625H5.625V16.875H1.875V20.625ZM0 22.5V15H7.5V22.5H0ZM16.875 5.625H20.625V1.875H16.875V5.625ZM15 7.5V0H22.5V7.5H15ZM17.5 22.5V18.75H15V16.25H20V20H22.5V22.5H17.5ZM12.5 13.75V11.25H17.5V13.75H12.5ZM7.5 13.75V11.25H5V8.75H12.5V11.25H10V13.75H7.5ZM8.75 7.5V2.5H11.25V5H13.75V7.5H8.75ZM2.8125 4.6875V2.8125H4.6875V4.6875H2.8125ZM2.8125 19.6875V17.8125H4.6875V19.6875H2.8125ZM17.8125 4.6875V2.8125H19.6875V4.6875H17.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrimage);
export default __webpack_public_path__ + "static/media/qrimage.87fcee1e081b7e1eab4694c1a1fe2e8d.svg";
export { ForwardRef as ReactComponent };